<script setup lang="ts">
import { ElCollapse, ElCollapseItem, ElLink } from "element-plus";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { tm } = useI18n();
const items = computed(() => tm("supgrade.faq.items"));
</script>

<template>
  <div class="supgrade-faq">
    <h2>{{ $t("supgrade.faq.heading") }}</h2>
    <el-collapse
      class="faq-accordion"
      accordion
    >
      <el-collapse-item
        v-for="item in items"
        :key="$rt(item.title)"
        :title="$rt(item.title)"
        :name="$rt(item.title)"
      >
        <div>
          {{ $rt(item.body) }}
          <ul v-if="item.bullets">
            <li
              v-for="bullet in item.bullets"
              :key="bullet"
            >
              {{ $rt(bullet) }}
            </li>
          </ul>
        </div>
      </el-collapse-item>
    </el-collapse>
    <p>
      {{ $t("supgrade.faq.support") }}
      <el-link
        target="_blank"
        rel="noopener noreferrer"
        type="primary"
        :underline="false"
        href="https://www.swipedon.com/sign-in-solutions"
        >{{ $t("supgrade.faq.supportLink") }}</el-link
      >
    </p>
  </div>
</template>
<style lang="css" scoped>
:deep(.so-collapse-item button) {
  font-size: 14px;
  font-weight: 500;
}
.faq-accordion {
  margin: 0.5rem 0 1rem 0;
  border-top: none;
}
ul {
  margin-top: 0.5rem;
}
li {
  font-size: var(--so-collapse-content-font-size);
  color: var(--so-collapse-content-text-color);
  line-height: 1.25rem;
}
</style>
